<app-tdo-progress-spinner *ngIf="isLoading"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" style="width: 100%; height: 100%; display: flex; font-size: 14px;" class="recall-main ui-dark-background">
  <div style="flex-basis: 340px; min-width: 340px; display: flex; flex-direction: column; padding: 4px;">
    <!--LEFT-->
    <div style="flex-basis: 30px; color: white; background-color: var(--tdo-primary); font-size: 16px; font-weight: 500; padding: 2px 0 0 3px; border-top-left-radius: var(--border-radius);">
      Final Report
    </div>
    <div style="margin-top: 0; background-color: var(--tdo-background);">
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">Date Completed:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1;">{{this.finalReportData.frDateCompleted ? (this.finalReportData.frDateCompleted | date: 'MM-dd-YY') : ''}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">Pulp Diagnosis:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500;">{{this.finalReportData.frPulpDiagnosis}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">Perial Diagnosis:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500;">{{this.finalReportData.frPerialDiagnosis}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">2nd Rec'd Time:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500;">{{this.finalReportData.frSecondRecievedTime}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">Preop Prognosis:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500;">{{this.finalReportData.frPreopPrognosis}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500;">Postop Prognosis:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500;">{{this.finalReportData.frPostopPrognosis}}</div>
      </div>
      <div style="display: flex; width: 100%;">
        <div style="flex: 1; text-align: right; font-weight: 500; line-height: 1; margin-top: 2px;">Restorative Recommendations:</div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex: 1; font-weight: 500; height: 100px; width: 100%; padding-right: 3px;"><textarea readonly style="margin-top: 5px; background-color: unset; border: 1px solid var(--tdo-primary); border-radius: 3px; outline: unset; resize: none; padding: 4px; overflow-y: auto; width: 100%; height: 94%; line-height: 1.1; font-size: 12px;">{{this.finalReportData.frRestorativeRecommendations}}</textarea></div>
      </div>
    </div>
    <div style="margin-top: 4px; flex-basis: 30px; color: white; background-color: var(--tdo-primary); font-size: 16px; font-weight: 500; padding: 2px 0 0 3px; border-top-left-radius: var(--border-radius);">
      Treatment
    </div>
    <div style="display: flex; background-color: var(--tdo-background);">
      <div style="flex: 1; display: flex; flex-direction: column">
        <div style="display: flex;">
          <div style="flex: 1; text-align: right; font-weight: 500;">Time:</div>
          <div style="flex-basis: 4px;"></div>
          <div style="flex: 1;">{{this.finalReportData.trtTime}}</div>
<!--          how long it took the event to complete-->
<!--          dataPatientCaseWorkItemEvent-->
        </div>
        <div style="display: flex;">
          <div style="flex: 1; text-align: right; font-weight: 500;">Difficulty:</div>
          <div style="flex-basis: 4px;"></div>
          <div style="flex: 1;">{{this.finalReportData.trtDifficulty}}</div>
        </div>
      </div>
      <div style="flex: 1; display: flex; flex-direction: column;">
        <div style="display: flex;">
          <div style="flex: 1; text-align: right; font-weight: 500;">Q Value:</div>
          <div style="flex-basis: 4px;"></div>
          <div style="flex: 1;">{{this.finalReportData.trtQValue}}</div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1; text-align: right; font-weight: 500;">P Value:</div>
          <div style="flex-basis: 4px;"></div>
          <!--WHAT IS P VALUE???-->
          <div style="flex: 1;">{{this.finalReportData.trtPValue}}</div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1; text-align: right; font-weight: 500;">Case Rating:</div>
          <div style="flex-basis: 4px;"></div>
          <!--WHAT IS CASE RATING???-->
          <div style="flex: 1;">{{this.finalReportData.trtCaseRating}}</div>
        </div>
      </div>
    </div>
    <div style="flex: 1; background-color: var(--tdo-background); margin-top: 4px;">
      <div style="display: flex; width: fit-content; margin-left: auto; margin-right: auto; margin-top: 6px;">
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">M</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; text-align: center;">{{this.finalReportData.surfaceM}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">MB</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceMB}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">B</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceB}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">DB</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceDB}}</div>
        </div>
      </div>
      <div style="display: flex; width: fit-content; margin-left: auto; margin-right: auto; margin-top: 6px;">
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">ML</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; text-align: center;">{{this.finalReportData.surfaceML}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">L</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceL}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">DL</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceDL}}</div>
        </div>
        <div style="display: flex; flex-direction: column; width: 30px;">
          <div style="text-align: center;">D</div>
          <div style="background-color: white; border: 1px solid rgba(0,0,0,0.2); border-radius: 2px; height: 20px; margin-left: 4px; text-align: center;">{{this.finalReportData.surfaceD}}</div>
        </div>
      </div>
    </div>
  </div>
  <div style="flex: 1; display: flex; flex-direction: column; overflow-x: hidden;">
    <!--MAIN-->

<!--    removed via tx3256-->
<!--    <div style="flex-basis: 48px; height: 48px; position: relative;">-->
<!--      <div style="width: 24px; position: absolute; right: 0; z-index: 2000;">-->
<!--        <div (click)="addRecall()" matTooltip="Add recall" style="z-index: 2000; cursor: pointer; margin-top: 3px; color: var(&#45;&#45;tdo-primary-accent);"><mat-icon>add_circle_outline</mat-icon></div>-->
<!--      </div>-->
<!--      <mat-tab-group style="height: 100%;" (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTabIndex">-->
<!--        <ng-container *ngFor="let rec of recalls; let index = index">-->
<!--          <mat-tab style="position: relative;">-->
<!--            &lt;!&ndash;TAB&ndash;&gt;-->
<!--            <ng-template mat-tab-label>-->
<!--              <div class="col" style="margin-left: 20px;">{{getTabName(rec)}}</div>-->
<!--              <button matTooltip="Delete Recall" style="color:black; position: relative;" mat-icon-button (click)="onCloseTabClick(rec)">-->
<!--                <mat-icon style="position: relative; right: 0;">close</mat-icon>-->
<!--              </button>-->
<!--            </ng-template>-->
<!--          </mat-tab>-->
<!--        </ng-container>-->
<!--      </mat-tab-group>-->
<!--    </div>-->

    <div style="flex: 1; display: flex;">
      <div style="flex: 2; background-color: var(--tdo-background); display: flex; flex-direction: column; padding: 3px;">
        <!--MAIN LEFT-->
        <div style="background-color: #00a8ff;   display: flex;    flex-direction: row;">
          Intended for: &nbsp;
          <div style="width: 120px;">
              <app-tdo-enum-select name="enumEndoRecallInTime" zVersion="L1" [validValueItemId]="selectedRecall.for_enumEndoRecallInTimeID" ></app-tdo-enum-select>
          </div>

          On: {{selectedRecall.for_RecallDate | date:'shortDate' }}
        </div>
        &nbsp;
        <div style="flex-basis: 20px; display: flex;">

          <div style="flex-basis: 220px; display: flex;">
            <div style="flex-basis: 60px; padding-top: 2px;">Auto Fill:</div>
            <div (click)="setAutofills(0)" style="cursor: pointer; background-color: var(--tdo-primary-accent); color: white; width: 20px; text-align: center; padding-top: 1px; max-height: 24px; border-radius: 2px; margin-left: 2px;">1</div>
            <div (click)="setAutofills(1)" style="cursor: pointer; background-color: var(--tdo-primary-accent); color: white; width: 20px; text-align: center; padding-top: 1px; max-height: 24px; border-radius: 2px; margin-left: 2px;">2</div>
            <div (click)="setAutofills(2)" style="cursor: pointer; background-color: var(--tdo-primary-accent); color: white; width: 20px; text-align: center; padding-top: 1px; max-height: 24px; border-radius: 2px; margin-left: 2px;">3</div>
            <div (click)="copyPrevious()" style="cursor: pointer; background-color: var(--tdo-primary-accent); color: white; width: 20px; text-align: center; padding-top: 1px; border-radius: 2px; margin-left: 2px; max-height: 24px; height: 24px; overflow: hidden;">
              <mat-icon style="position: relative; top: -1px; left: -2px; transform: scale(0.6, 0.6);">content_copy</mat-icon>
            </div>
          </div>

          <div style="flex: 1; display: flex;">

            <div style="padding-top: 2px; margin-right: 2px;">This Recall:</div>
            <div style="flex: 1; height: 24px; overflow: hidden; border-bottom: 1px solid black; position: relative; top: -1px;">
              <app-tdo-enum-select name="enumEndoRecallInTime" [validValueItemId]="selectedRecall.enumEndoRecallInTimeID" (enumSelected)="selectedRecall.enumEndoRecallInTimeID = $event.ValidValueItemId; save();"></app-tdo-enum-select>
            </div>
            <div style="flex-basis: 120px; padding: 2px 0 0 3px;">
              <div style="background-color: white; font-size: 12px; padding: 2px; border-radius: 2px;">{{getDate(selectedRecall?.ActualRecallDate ) | date:'shortDate'}}</div>
            </div>
          </div>
        </div>
        <div style="flex: 1; display: flex; flex-direction: column; padding-top: 8px;">
          <div class="recall-row">
            <div class="recall-row-label">Has the tooth been restored?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallToothResoredID" (change)="selectedRecall.enumEndoRecallToothResoredID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of restoredValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Coronal Leakage?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallCoronalLeakID" (change)="selectedRecall.enumEndoRecallCoronalLeakID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of coronalValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Asymptomatic and Functional?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallAsymFuncID" (change)="selectedRecall.enumEndoRecallAsymFuncID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of asymValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Has lucency decreased in size?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallLucencyID" (change)="selectedRecall.enumEndoRecallLucencyID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of lucencyValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Is PDL normal?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallPDLID" (change)="selectedRecall.enumEndoRecallPDLID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of pdlidValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Palpation soreness?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallPalpSoreID" (change)="selectedRecall.enumEndoRecallPalpSoreID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of palpValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Percussion tests?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 20px;" [ngModel]="selectedRecall.enumEndoRecallPercussID" (change)="selectedRecall.enumEndoRecallPercussID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of percussValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Mobility</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 70px;" [ngModel]="selectedRecall.enumEndoRecallMobilityID" (change)="selectedRecall.enumEndoRecallMobilityID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of mobilityValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">Sinus tract present?</div>
            <div class="recall-row-content">
              <mat-radio-group style="display: flex; min-width: 50px;" [ngModel]="selectedRecall.enumEndoRecallSinusTrackID" (change)="selectedRecall.enumEndoRecallSinusTrackID = $event.value; save();">
                <mat-radio-button style="margin-right: 10px; min-width: 50px;" *ngFor="let rb of sinusValues" [value]="rb.ValidValueItemId">{{rb.ItemDisplayValue}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="recall-row">
            <div class="recall-row-label">
              Probings
              <br />
              <div style="color: var(&#45;&#45;tdo-primary-accent); cursor: pointer;"><mat-icon style="transform: scale(0.6, 0.6)">content_copy</mat-icon></div>
              <br />
              <br />
            </div>
            <div class="recall-row-content" style="display: flex; flex-direction: column;">
              <div style="flex-basis: 100px; width: 50%; display: flex; flex-direction: column;">
                <div style="display: flex">
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">M</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingM_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingM_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">ML</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingML_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingML_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">MB</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingMB_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingMB_enumProbingDepthID = $event.ValidValueItemId; save($event);" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">L</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingL_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingL_enumProbingDepthID = $event.ValidValueItemId; save($event);" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">B</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingB_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingB_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">DL</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingDL_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingDL_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                </div>
                <div style="display: flex">
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">DB</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingDB_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingDB_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                  <div style="flex: 1; display: flex;">
                    <div style="flex-basis: 30px; margin-right: 6px; padding-top: 4px; text-align: right;">D</div>
                    <div style="flex: 1; border-bottom: 1px solid black;">
                      <app-tdo-enum-select [allowReset]="false" placeholder="" [validValueItemId]="selectedRecall.probingD_enumProbingDepthID"
                                           (enumSelected)="selectedRecall.probingD_enumProbingDepthID = $event.ValidValueItemId; save();" name="enumProbingDepth"></app-tdo-enum-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="recall-row" style="margin-top: 8px;">
            <div class="recall-row-label" style="margin-top: 4px;">Current Finding:</div>
            <div class="recall-row-content">
              <div style="height: 25px; width: 90%;">
                <app-tdo-enum-select placeholder="" [validValueItemId]="selectedRecall.enumEndoRecallCurrentFindingID"
                                     (enumSelected)="selectedRecall.enumEndoRecallCurrentFindingID = $event.ValidValueItemId; save();" name="enumEndoRecallCurrentFinding"></app-tdo-enum-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="flex-basis: 6px;"></div>
      <div #rightColumn style="flex: 1; background-color: var(--tdo-background); display: flex; flex-direction: column;">
        <!--MAIN RIGHT-->
        <div style="padding: 3px; font-weight: 500;">Images for this Recall</div>
        <div [style.width.px]="getWidth()" [style.height.px]="getWidth()" style="padding: 3px;">
          <div style="width: 100%; height: 100%;">
            <app-tdo-document-viewer #documentViewer [objectId]="selectedRecall.CaseRecallID" [tags]="['0000001D-1000-0000-0000-000000000088']"></app-tdo-document-viewer>
          </div>
          <div style="display: flex; height: 24px; color: var(--tdo-primary-accent);">
            <div style="flex-basis: 24px;">
              <div [hidden]="documentViewer.index === 0" (click)="documentViewer.previous()" style="cursor: pointer; width: 24px;">
                <mat-icon>chevron_left</mat-icon>
              </div>
            </div>
            <div style="flex: 1;"></div>
<!--            <div (click)="documentViewer.openCurrentInDraw()" matTooltip="Open current image in draw" style="cursor: pointer;"><mat-icon>image</mat-icon></div>-->
            <div (click)="openOrganizer()" matTooltip="Add image" style="cursor: pointer;"><mat-icon>image</mat-icon></div>
            <div style="flex-basis: 6px;"></div>
            <div (click)="documentViewer.openAllInDraw()" matTooltip="Open all images in Studio" style="cursor: pointer;">
              <mat-icon>photo_library</mat-icon>
            </div>
            <div style="flex: 1;"></div>
            <div style="flex-basis: 24px;">
              <div [hidden]="documentViewer.index === documentViewer.documents.length - 1" (click)="documentViewer.next()" style="cursor: pointer; width: 24px;">
                <mat-icon>chevron_right</mat-icon>
              </div>
            </div>
          </div>
          <div style="display: flex; margin-top: 10px;">
            <mat-checkbox style="margin-top: 8px;">Send Recall Report</mat-checkbox>
            <div style="flex: 1;"></div>
            <button class="tdo-button tdo-save">Send Now</button>
          </div>
          <div style="display: flex; margin-top: 6px;">
            <div>Date Sent:</div>
            <div style="background-color: white; border-radius: var(--border-radius);"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex-basis: 3px; background-color: var(--tdo-primary);"></div>
    <div style="flex-basis: 20px; display: flex; flex-direction: column; padding-top: 3px; background-color: var(--tdo-background);">
      <div style="flex-basis: 20px; margin-left: auto; margin-right: auto; display: flex;">
        <div (click)="createNote()" matTooltip="Create Note" style="color: var(--tdo-primary-accent); margin-right: 3px; cursor: pointer;"><mat-icon>note_alt</mat-icon></div>
        <div matTooltip="Print" style="color: var(--tdo-primary-accent); margin-left: 3px; cursor: pointer;"><mat-icon>print</mat-icon></div>
      </div>
    </div>
    <!--<div style="flex-basis: 20px; width: 100%; background-color: var(&#45;&#45;tdo-background);"></div>-->
    <div style="flex-basis: 60px; background-color: var(--tdo-background); padding-top: 20px;">
      <div style="width: 740px; margin-left: auto; margin-right: auto;  margin-bottom: 4px; display: flex;">
        <div style="display: flex; flex-basis: 240px; background-color: var(--tdo-background);">
          <div style="flex-basis: 80px; margin-right: 4px; padding-top: 3px;">Next Recall: </div>
          <div style="flex-basis: 150px; height: 30px;">
            <app-tdo-enum-select name="enumEndoRecallInTime" (enumSelected)="setNextRecallTime($event);"></app-tdo-enum-select>
          </div>
        </div>
        <div style="margin-left: 10px; display: flex; flex-basis: 220px; background-color: var(--tdo-background);">
          <div style="flex-basis: 140px; margin-right: 4px; padding-top: 3px;">On or Around Date: </div>
          <div style="flex-basis: 100px; height: 30px; background-color: white; border-radius: 3px; border: 1px solid rgba(0,0,0,0.2); text-align: center;padding-top: 4px;">
            <!--NEXT DATE?-->
            {{onOrAroundDate | date: 'shortDate'}}
          </div>
        </div>
        <div style="flex-basis: 130px; margin-left: 10px;">
          <mat-checkbox>Super Recall</mat-checkbox>
        </div>
        <button [disabled]="!nextRecallEnumId" (click)="createNextRecall()" style="width: 135px;" class="tdo-button tdo-save">Create Recall</button>
      </div>
    </div>
  </div>
</div>
